"use strict";
/* eslint-disable consistent-return */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Safely parses a JSON string without throwing
 * (will just return `undefined` if JSON parsing failed)
 *
 * @example
 * import safeParse from '@carvana/futilities/safeParse';
 * safeParse('"{"one":1,"two":2,"three":3}"')
 * // () => {one: 1, two: 2, three: 3}
 * safeParse('')
 * // () => undefined
 * safeParse(42)
 * // () => undefined
 */
function safeParse(inputString) {
    try {
        if (/^({|\[)/.test(inputString)) {
            return JSON.parse(inputString);
        }
    }
    catch (ex) {
        return null;
    }
}
exports.default = safeParse;
//# sourceMappingURL=safeParse.js.map